import {
  Button,
  CircularProgress,
  DialogActions,
  Grid,
  TextField,
} from "@material-ui/core";
import { useFormik } from "formik";
import * as yup from "yup";
import { useEffect, useState, useCallback } from "react";
import { Alert, Autocomplete } from "@material-ui/lab";
import { useSearchClientsQuery } from "../../../services/clients/clientsServices";
import { useCreateUserClientRelationMutation } from "../../../services/users/usersService";

interface props {
  idUsuario: number;
  handleClose: () => void;
  refetch: () => void;
}

const AddClientToUserForm = ({ idUsuario, handleClose, refetch }: props) => {
  const [search, setSearch] = useState("");
  const { data, isLoading } = useSearchClientsQuery(
    {
      search,
    },
    { refetchOnMountOrArgChange: true }
  );

  const tipoOptions = [
    { label: "EXPORT", value: "EXP" },
    { label: "IMPORT", value: "IMP" },
    { label: "AMBOS", value: "AMBOS" },
  ];

  const rows =
    data?.clients?.map((cl) => ({
      value: cl.id,
      label: cl.nombre,
    })) || [];

  const schema = yup.object().shape({
    cliente: yup.string().required("Empresa es requerida"),
    tipo: yup.string().required("Tipo es requerido"),
  });

  const [
    createRelation,
    { isSuccess, isError, error, isLoading: isLaodingCreate },
  ] = useCreateUserClientRelationMutation();

  const { errors, touched, handleSubmit, setFieldValue, values } = useFormik({
    initialValues: {
      cliente: "",
      tipo: "",
    },
    validationSchema: schema,
    onSubmit(values) {
      createRelation({
        estado: "A",
        id_cliente: Number(values.cliente),
        id_usuario: idUsuario,
        tipo: values.tipo,
      });
    },
  });

  const handleSuccess = useCallback(() => {
    refetch();
    setTimeout(() => {
      handleClose();
    }, 300);
  }, [refetch, handleClose]);

  useEffect(() => {
    isSuccess && handleSuccess();
  }, [isSuccess, handleSuccess]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Autocomplete
          value={rows.find((st) => String(st.value) === values.cliente)}
          options={rows}
          getOptionLabel={(option) => option.label}
          getOptionSelected={(opt, val) => opt.value === val.value}
          onChange={async (_, val) => {
            if (val) {
              await setFieldValue("cliente", val.value);
            } else {
              await setFieldValue("cliente", "");
              setSearch("");
            }
          }}
          loading={isLoading}
          renderInput={(props) => (
            <TextField
              {...props}
              label="Buscar Empresa"
              placeholder="Ingrese nombre o ruc"
              variant="outlined"
              fullWidth
              onChange={({ currentTarget }) => {
                currentTarget.value.length > 2
                  ? setSearch(currentTarget.value.toUpperCase())
                  : setSearch("");
              }}
              error={Boolean(errors.cliente && touched.cliente)}
              helperText={
                Boolean(errors.cliente && touched.cliente) && errors.cliente
              }
              InputProps={{
                ...props.InputProps,
                endAdornment: (
                  <>
                    {isLoading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {props.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
          filterOptions={(x) => x}
          noOptionsText="No hay opciones disponibles"
        />
      </Grid>
      <Grid item xs={12}>
        <Autocomplete
          options={tipoOptions}
          getOptionLabel={(opt) => opt.label}
          getOptionSelected={(opt, val) => opt.value === val.value}
          onChange={(e, val) => {
            setFieldValue("tipo", val?.value || "");
          }}
          renderInput={(params) => (
            <TextField
              variant="outlined"
              label="Tipo"
              {...params}
              error={Boolean(errors.tipo && touched.tipo)}
              helperText={Boolean(errors.tipo && touched.tipo) && errors.tipo}
            />
          )}
        />
      </Grid>
      {isSuccess && (
        <Grid item xs={12}>
          <Alert severity="success">SE AGREGO LA EMPRESA CORRECTAMENTE</Alert>
        </Grid>
      )}
      {isError && (
        <Grid item xs={12}>
          <Alert severity="error">{String(error)}</Alert>
        </Grid>
      )}
      <Grid item xs={12}>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button
            disabled={isLaodingCreate || isSuccess}
            onClick={() => {
              handleSubmit();
            }}
            variant="contained"
            color="primary"
          >
            Guardar
          </Button>
        </DialogActions>
      </Grid>
    </Grid>
  );
};

export default AddClientToUserForm;
